import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import ResultCard from '../components/ResultCard';
import BoostCard from '../components/BoostCard';
import type { AnalyzeResponse } from '../types';

export default function ResultPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const result = location.state?.result as AnalyzeResponse | undefined;

    // Redirect to home if no result
    if (!result) {
        return (
            <div className="min-h-screen bg-primary-50 flex items-center justify-center">
                <div className="text-center">
                    <p className="text-gray-600 mb-4">No scan result found</p>
                    <button
                        onClick={() => navigate('/')}
                        className="btn-primary"
                    >
                        Go Home
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-primary-50">
            <Header />

            <main className="max-w-lg mx-auto px-4 py-6 safe-bottom">
                {/* Dopamine Boost - Show first for maximum impact! */}
                <div className="mb-6">
                    <BoostCard boost={result.boost_payload} action={result.action} />
                </div>

                {/* Detailed Result */}
                <ResultCard
                    itemName={result.item_name}
                    material={result.material_guess}
                    confidence={result.confidence}
                    action={result.action}
                    prepSteps={result.prep_steps}
                    uncertaintyReason={result.uncertainty_reason}
                />

                {/* Follow-up Question */}
                {result.followup_question && (
                    <div className="card bg-blue-50 border-blue-200 mb-4">
                        <div className="flex items-start gap-2">
                            <span className="text-xl">💬</span>
                            <div>
                                <p className="font-semibold text-blue-900">Want to know more?</p>
                                <p className="text-sm text-blue-700 mt-1">{result.followup_question}</p>
                            </div>
                        </div>
                    </div>
                )}

                {/* Action Buttons */}
                <div className="flex gap-3 mt-6">
                    <button
                        onClick={() => navigate('/')}
                        className="flex-1 btn-secondary"
                    >
                        Scan Another
                    </button>
                    <button
                        onClick={() => {
                            // Share functionality
                            if (navigator.share) {
                                navigator.share({
                                    title: 'BinIt - I just recycled!',
                                    text: `I just learned that ${result.item_name} should be ${result.action === 'recycle' ? 'recycled' : result.action === 'trash' ? 'trashed' : 'taken to a special drop-off'}! 🌱`,
                                    url: window.location.origin
                                });
                            }
                        }}
                        className="flex-1 btn-primary"
                    >
                        Share 🎉
                    </button>
                </div>
            </main>
        </div>
    );
}
